// 开发模式，且在 iframe 内
if (process.env.NODE_ENV !== 'production' && window.parent !== window) {
  module.exports = require('./embedded');
} else {
  module.exports = require('./AppContainer');
}
